/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} LeftInputs */

const en_left = /** @type {(inputs: LeftInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Left`)
};

const es_left = /** @type {(inputs: LeftInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Izquierda`)
};

const fr_left = /** @type {(inputs: LeftInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gauche`)
};

const de_left = /** @type {(inputs: LeftInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Links`)
};

const ja_left = /** @type {(inputs: LeftInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`左`)
};

const zh_left = /** @type {(inputs: LeftInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`左`)
};

const ar_left = /** @type {(inputs: LeftInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`يسار`)
};

const id_left = /** @type {(inputs: LeftInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kiri`)
};

const it_left = /** @type {(inputs: LeftInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sinistra`)
};

const ru_left = /** @type {(inputs: LeftInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Лево`)
};

const pt_left = /** @type {(inputs: LeftInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Esquerda`)
};

const ko_left = /** @type {(inputs: LeftInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`왼쪽`)
};

/**
* | output |
* | --- |
* | "Left" |
*
* @param {LeftInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const left = /** @type {((inputs?: LeftInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<LeftInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_left(inputs)
	if (locale === "es") return es_left(inputs)
	if (locale === "fr") return fr_left(inputs)
	if (locale === "de") return de_left(inputs)
	if (locale === "ja") return ja_left(inputs)
	if (locale === "zh") return zh_left(inputs)
	if (locale === "ar") return ar_left(inputs)
	if (locale === "id") return id_left(inputs)
	if (locale === "it") return it_left(inputs)
	if (locale === "ru") return ru_left(inputs)
	if (locale === "pt") return pt_left(inputs)
	return ko_left(inputs)
});